import React, { Component } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'

import {
  get,
  post,
  sess_get,
  sess_post,
  sess_delete,
} from "../utils/HttpRequests";

class KeywordFilter extends Component {
  state = {};

  async componentDidMount() {
    let keywords = await this.getKeywords();
    this.setState({ keywords }, () => {
      console.log(this.state.keywords);
    });
  }

  getKeywords = async () => {
    return get("admin/console/keywords")
      .then((response) => {
        return response.data.response;
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  handleAddKeyWordFilter = async () => {
    const { keyword } = this.state;
    const session_token = localStorage.getItem("admin-panel-sessionToken");
    if (keyword) {
      sess_post("admin/console/keywords", session_token, { keyword })
        .then((response) => {
          this.setState({ keyword: "",error:"" });
        })
        .catch((err) => {
          console.log(err.response.data.error.reason);
          let message ="Internal Server Error"
          if(err && err.response && err.response.data && err.response.data.error){
            message = err.response.data.error.reason;
          }
          this.setState({error:message},()=>{
            // console.log(this.state)
          })
        });
    }
  };

  onKeyWordInputChange = async (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  componentDidUpdate = async (props, prevState) => {
    if (
      prevState.keyword != this.state.keyword &&
      this.state.keyword.length == 0
    ) {
      const keywords = await this.getKeywords();
      this.setState({ keywords,error:'' });
    }
  };

  handleDelete = async (id) => {
    const session_token = localStorage.getItem("admin-panel-sessionToken");
    if (id) {
      sess_delete("admin/console/keywords", session_token, { _id: id })
        .then(async (response) => {
          this.setState({ keywords: await this.getKeywords(),error:'' });
        })
        .catch((err) => {
          console.log(err);
         this.setState({error:'Keyword Not Deleted'});
        });
    }
  };

  render() {
    const { keywords = [] } = this.state;
    return (
      <>
        <div class="shadow-panel">
          <div class="col-sm-12">
            <center>
              <h4>Add Keyword</h4>
            </center>
          </div>
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <div>
              <form class="form-horizontal">
                <div
                  class="form-group"
                  style={{ display: "flex", justifyContent: "space-evenly" }}
                >
                  <div class="col-sm-5" style={{"padding-left":"1px"}}>
                    <input
                      class="form-control"
                      id="keyword"
                      placeholder="Enter Keyword"
                      name="keyword"
                      type="text"
                      value={this.state.keyword}
                      onChange={this.onKeyWordInputChange}
                      required
                    />
                  </div>
                  <div class="col-sm-7" style={{"padding-left":"90px"}}>
                    <button
                      type="button"
                      class="btn btn-primary"
                      onClick={this.handleAddKeyWordFilter}
                    >
                      Add to Keyword filter List
                    </button>
                  </div>
                </div>
               {this.state.error && <div class="text text-danger">{this.state.error}</div>}
              </form>
              <div class="shadow-panel">
                <table class="table table-hover mb-table">
                  <thead class="thead-light">
                    <tr>
                      <th>Keywords</th>
                      <th>-</th>
                    </tr>
                  </thead>

                  <tbody>
                    {keywords.map((keyword) => {
                      return (
                        <tr>
                          <td class="">{keyword.keyword}</td>
                          <td>
                            <a
                              href="javascript:void(0)"
                              class="icon pls"
                              title="Delete"
                              onClick={() => this.handleDelete(keyword._id)}
                            >
                              <span
                                name={keyword._id}>
                                <FontAwesomeIcon icon={faTrash} />
                              </span>
                            </a>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default KeywordFilter;
